// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aNle","content":"styles_content__y_P-Q","row":"styles_row__1dDx2","footer":"styles_footer__inCUg","phraseLength":"styles_phraseLength__2Xr2i"};